import { isSaasCommercialBuyer } from "@/lib/accountStatus";
import { canShowCommercialLicenseRequestUi } from "@/lib/commercialLicenseRequests";
import { isLicenseCommercialFocusQuery } from "@/modules/config/configuracionRoutes";

/**
 * ¿Tratar al usuario como diseñador puro (sin vista comprador)?
 * Falso en «Ver como comprador» o comprador SaaS titular (p. ej. despachobnt con onboarding).
 */
export function blocksBuyerCommercialLicenseUi(
  user = {},
  { buyerPreviewActive = false, isPlatformDesigner = false } = {},
) {
  if (buyerPreviewActive) return false;
  if (isSaasCommercialBuyer(user)) return false;
  return Boolean(isPlatformDesigner);
}

/**
 * ¿Mostrar vista limpia Mi Negocio / Solicitud de licencia (sin acordeón técnico)?
 * @param {{ searchParams?: URLSearchParams|object, user?: object, workspaceMode?: string, canSwitch?: boolean, isPlatformDesigner?: boolean, buyerPreviewActive?: boolean, isEmisorHub?: boolean }} ctx
 */
export function shouldUseLicenseCommercialFocusView(ctx = {}) {
  if (ctx.isEmisorHub) return false;
  if (
    blocksBuyerCommercialLicenseUi(ctx.user, {
      buyerPreviewActive: ctx.buyerPreviewActive,
      isPlatformDesigner: ctx.isPlatformDesigner,
    })
  ) {
    return false;
  }
  if (!isLicenseCommercialFocusQuery(ctx.searchParams)) return false;
  return canShowCommercialLicenseRequestUi(ctx.user, {
    workspaceMode: ctx.workspaceMode,
    canSwitch: ctx.canSwitch,
    buyerPreviewUx: ctx.buyerPreviewActive,
  });
}
